<template>
    <section class="column is-3">
        <div @click.prevent="$emit('click', employee)" class="employee-container">
            <figure class="thumbnail">
                <img :src="employee.thumbnail.size.full" :alt="employee.name">
            </figure>
            <div class="employee-description">
                <h3 v-text="employee.name"></h3>
                <p v-text="employee.role"></p>
            </div>
            <div class="cta"><span class="icon"><i class="fas fa-info"></i></span></div>
            <div class="background"
                 :style="'background-image: url('+employee.secondary.size.full+')'"></div>
        </div>
    </section>
</template>
<script>
    export default {
        props: {
            employee: {
                type: Object,
                required: true
            }
        }
    }
</script>